// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33xUJ","right":"styles_right__19Jiw"};